import { ISbStoriesParams } from '@storyblok/react';
import { IS_PROD } from 'src/envVariables';
import { VERSION } from './types';

export const sbParams: ISbStoriesParams = {
  get version() {
    return IS_PROD ? VERSION.PUBLISHED : VERSION.DRAFT;
  },
  // To get all required data to link to a story     is required
  // https://www.storyblok.com/docs/guide/in-depth/rendering-the-link-field#the-story-link-type
  // no more than 500 links should be in one storyblok api response:
  // https://www.storyblok.com/docs/technical-limits
  resolve_links: 'url',
};

export const getStoriesUrl = (slug: string = '') => `cdn/stories/${slug}`;
